import React from 'react';
import { Flex, Button, Text, Box } from '../design-system';
import styled, { css } from 'styled-components';
import ModalForm from './ModalForm';
import SearchFilter from './SearchFilter';

const FilterItem = styled(Box)(
  ({ theme }) => css`
    background-color: ${theme.colors.primaryLight};
    color: ${theme.colors.white};
    border-radius: 8px;
  `,
);

interface TableFilterProps {
  filtersToDisplay: Array<{ filter: string; displayValue: any }>;
  search?: string;
  filters?: any;
  handleSearch: (value: string) => void;
  saveFilters: (values: any) => void;
  isOpen: boolean;
  clearFilters: () => void;
  filterFields: any[];
  toggleModal: () => void;
}

const TableFilter = ({
  filtersToDisplay,
  search,
  filters,
  handleSearch,
  saveFilters,
  isOpen,
  clearFilters,
  filterFields,
  toggleModal,
}: TableFilterProps) => {
  return (
    <Flex p="0 36px 0 26px" flexDirection="column">
      <Flex width="100%" mb={3}>
        <Box width="100%" mr={3}>
          <SearchFilter
            onFilter={handleSearch}
            initialValue={search}
            floating
          />
        </Box>
        <Box mr={3}>
          <Button
            onClick={toggleModal}
            variant="green"
            style={{ height: 48, fontSize: '0.8rem' }}
          >
            Filters
          </Button>
        </Box>
        <Button
          onClick={clearFilters}
          variant="red"
          style={{ height: 48, fontSize: '0.8rem' }}
        >
          Clear Filters
        </Button>
      </Flex>
      {!!filtersToDisplay.length && (
        <>
          <Text fontSize="1.2rem" fontWeight={600}>
            Current Filters:
          </Text>
          <Flex mt={2}>
            {filtersToDisplay.map(({ filter, displayValue }) => (
              <FilterItem mr={2} p="5px 12px" key={filter}>
                <Text fontWeight={600} style={{ textTransform: 'capitalize' }}>
                  {filter}:{' '}
                </Text>
                {displayValue}
              </FilterItem>
            ))}
          </Flex>
        </>
      )}
      <ModalForm
        title="Filters"
        isOpen={isOpen}
        onSubmit={saveFilters}
        onClose={toggleModal}
        initialValues={filters}
        fields={filterFields}
        buttonText="Apply Filters"
        oneColumn
        isConfirmation={false}
      />
    </Flex>
  );
};

export default TableFilter;
